export const TRANSFORMABLE_COLUMNS = [
  {
    target: 'patient_monitors.pressure_risk',
    label: 'Pressure Risk',
    dataType: 'number',
    group: 'Patient Monitors'
  },
  {
    target: 'patient_monitors.pressure_risk_updated_at',
    label: 'Pressure Risk Updated At',
    dataType: 'datetime',
    group: 'Patient Monitors',
    dateFormat: 'lll'
  },
  {
    target: 'patient_monitors.acuity_score',
    label: 'Attention Score',
    dataType: 'number',
    group: 'Patient Monitors'
  },
  {
    target: 'patient_monitors.acuity_score_updated_at',
    label: 'Attention Score Updated At',
    dataType: 'datetime',
    group: 'Patient Monitors',
    dateFormat: 'lll'
  },
  {
    target: 'patients.dob',
    label: 'Date of Birth',
    dataType: 'datetime',
    group: 'Patients',
    dateFormat: 'L',
    withoutTimezone: true,
    mask: 'dob'
  }
]

export function getColumnByTarget(target) {
  return TRANSFORMABLE_COLUMNS.find(c => c.target === target)
}

export function getColumnsByGroup() {
  return TRANSFORMABLE_COLUMNS.reduce((acc, col) => {
    if (!acc[col.group]) acc[col.group] = []
    acc[col.group].push(col)
    return acc
  }, {})
}
